import { defaultInstructions } from './fields';

const amountPattern = /^\d+(\.\d{1,2})?$/;
const emailPattern = /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/;

export const createEmptyOrderForm = () => ({
    requestId: crypto.randomUUID(),
    organizationId: '',
    organizationName: '',
    poNumber: '',
    customerName: '',
    customerEmail: '',
    familyReference: '',
    billingContact: '',
    billingEmail: '',
    billingAddress: '',
    product: "Mr. Reed's STEAM Lab Membership",
    amount: '49.99',
    accessDays: 365,
    paymentInstructions: defaultInstructions,
    dueDate: '',
    notes: '',
});

export const hasValidOrderFields = (form) => {
    const amount = Number(form.amount);
    const accessDays = Number(form.accessDays);
    return Boolean(
        form.organizationId
        && form.poNumber.trim()
        && form.product.trim()
        && amountPattern.test(form.amount)
        && amount > 0
        && amount <= 1000000
        && Number.isInteger(accessDays)
        && accessDays >= 1
        && accessDays <= 3650
        && form.customerName.trim()
        && emailPattern.test(form.customerEmail.trim())
        && emailPattern.test(form.billingEmail.trim())
        && form.paymentInstructions.trim(),
    );
};

export const hasValidAmountFormat = (amount) => amountPattern.test(amount);
